import { render, staticRenderFns } from "./epb-facets-container.component.vue?vue&type=template&id=0b6da80a&scoped=true"
import script from "./epb-facets-container.component.vue?vue&type=script&lang=ts"
export * from "./epb-facets-container.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-facets-container.component.vue?vue&type=style&index=0&id=0b6da80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6da80a",
  null
  
)

export default component.exports